import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useRef, useEffect, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { useResizeObserver } from '@wix/da-hooks/pkg/useResizeObserver';
import { useScrollAware } from '@wix/da-hooks/pkg/useScrollAware';
import StickyContent from './StickyContent';
function getHeight(node) {
    if (!node) {
        return 0;
    }
    return node.getBoundingClientRect().height;
}
const EMPTY_REF = {
    current: null
};
const Sticky = (_param)=>{
    var { marginTop = 0, marginLeft: marginLeftProp = 0, bottomStop = 0, usePortal, scrollNode, observeHeightResize } = _param, contentProps = _object_without_properties(_param, [
        "marginTop",
        "marginLeft",
        "bottomStop",
        "usePortal",
        "scrollNode",
        "observeHeightResize"
    ]);
    const rootRef = useRef(null);
    const innerRef = useRef(null);
    const [minHeight, setMinHeight] = useState(getHeight(innerRef.current));
    const [top, setTop] = useState(0);
    const [marginLeft, setMarginLeft] = useState(typeof marginLeftProp === 'number' ? marginLeftProp : 0);
    const checkIfStuck = useCallback(()=>{
        if (!rootRef.current) {
            return false;
        }
        const rootRect = rootRef.current.getBoundingClientRect();
        return rootRect.top - marginTop <= 0;
    }, [
        marginTop
    ]);
    const [isStuck, setIsStuck] = useState(checkIfStuck());
    const updateTop = useCallback(({ scrollTop, scrollHeight })=>{
        const isStuckNow = checkIfStuck();
        setIsStuck(isStuckNow);
        const height = minHeight || getHeight(innerRef.current);
        setMinHeight(height);
        if (isStuckNow && bottomStop !== 0) {
            const diff = scrollHeight - scrollTop - height - marginTop - bottomStop;
            setTop(diff < 0 ? diff : 0);
            return;
        }
        setTop(0);
    }, [
        checkIfStuck,
        minHeight,
        bottomStop,
        marginTop
    ]);
    useScrollAware(updateTop, scrollNode !== null && scrollNode !== void 0 ? scrollNode : undefined);
    useResizeObserver(observeHeightResize ? innerRef : EMPTY_REF, useCallback(()=>{
        const currentHeight = getHeight(innerRef.current);
        if (minHeight !== currentHeight) {
            setMinHeight(currentHeight);
        }
    }, [
        minHeight
    ]));
    useEffect(()=>{
        if (marginLeftProp === 'preserve') {
            const clientRectLeft = innerRef.current.getBoundingClientRect().left;
            setMarginLeft(clientRectLeft);
        }
    }, [
        marginLeftProp
    ]);
    const content = /*#__PURE__*/ React.createElement(StickyContent, _object_spread({
        isStuck: isStuck,
        top: top,
        marginTop: marginTop,
        marginLeft: marginLeft,
        ref: innerRef
    }, contentProps));
    return /*#__PURE__*/ React.createElement("div", {
        ref: rootRef,
        style: {
            minHeight
        }
    }, usePortal && isStuck ? /*#__PURE__*/ ReactDOM.createPortal(content, document.body) : content);
};
Sticky.displayName = 'Sticky';
export default Sticky;

//# sourceMappingURL=Sticky.js.map